import React, { useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Details = (props) => {
  const { userdata } = props;
  const { register, formState: { errors }, handleSubmit } = useForm({ mode: 'onChange' });
  const history = useNavigate();
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const onSubmit = (data) => {
    const request = {};
    request.mentee_id = userdata.mentee_id;
    request.mentor_id = userdata.mentor_id;
    request.review = data.review;
    request.user_role = "Mentee";
    agent
      .post(API.LOAD_CUSTOMER + "/updateReview", request)
      .then((res) => {
        setPopupMessage(res.data.message);
        setShowPopup(true);
      })
      .catch((err) => {
        setPopupMessage(err.message || "Something went wrong.Please try again.");
        setShowPopup(true);
      });
  };
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <label className="form-label" htmlFor="review">Write a review*</label>
                <Form.Control
                  as="textarea"
                  className={
                    errors?.review ? "form-control is-invalid" : "form-control"
                  }
                  name="review"
                  defaultValue={userdata.mentee_review}
                  aria-invalid={errors?.review ? "true" : "false"}
                  {...register("review", {
                    required: true,
                    maxLength: 600,
                  })}
                />
                {errors?.review && errors?.review?.type === "required" && (
                  <label className="customeValidationText text-left" htmlFor="review">
                    Please enter review
                  </label>
                )}
                {errors?.review && errors?.review?.type === "maxLength" && (
                  <label className="customeValidationText text-left" htmlFor="review">
                    Review should not more than 600 characters
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <Button
                    className="btn loginsubmit nextbtn ml-2"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
          props.onHide();      // close parent modal
          history("/my-mentors"); // navigate after user clicks OK
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    mentee_review: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Details;
